import { startOfMonth, endOfMonth, format, addMonths, subMonths, startOfDay } from 'date-fns';
import { UTCDate } from '@date-fns/utc';

export type MonthData = {
  label: string;
  startDate: string;
  endDate: string;
  date: UTCDate;
};

export const getCurrentMonth = (): MonthData => {
  const dateNow = new UTCDate();
  const monthStart = startOfMonth(dateNow);
  const monthEnd = endOfMonth(dateNow);

  return {
    label: monthStart.toLocaleString('default', { month: 'long' }),
    startDate: format(monthStart, 'yyyy-MM-dd'),
    endDate: format(monthEnd, 'yyyy-MM-dd'),
    date: dateNow,
  };
};

export const getMonth = (date: UTCDate): MonthData => {
  const monthStart = startOfMonth(date);
  const monthEnd = endOfMonth(date);

  return {
    label: monthStart.toLocaleString('default', { month: 'long' }),
    startDate: format(monthStart, 'yyyy-MM-dd'),
    endDate: format(monthEnd, 'yyyy-MM-dd'),
    date: new UTCDate(),
  };
};

export const getPreviousMonth = (date: UTCDate): MonthData => {
  const previousMonth = subMonths(date, 1);
  const previousMonthStart = startOfMonth(previousMonth);
  const previousMonthEnd = endOfMonth(previousMonth);

  return {
    label: previousMonthStart.toLocaleString('default', { month: 'long' }),
    startDate: format(previousMonthStart, 'yyyy-MM-dd'),
    endDate: format(previousMonthEnd, 'yyyy-MM-dd'),
    date: previousMonth,
  };
};

export const getNextMonth = (date: UTCDate): MonthData => {
  const nextMonth = addMonths(date, 1);
  const nextMonthStart = startOfMonth(nextMonth);
  const nextMonthEnd = endOfMonth(nextMonth);

  return {
    label: nextMonthStart.toLocaleString('default', { month: 'long' }),
    startDate: format(nextMonthStart, 'yyyy-MM-dd'),
    endDate: format(nextMonthEnd, 'yyyy-MM-dd'),
    date: nextMonth,
  };
};

export const getUTCDate = (year: number, month: number, date?: number) => new UTCDate(year, month, date);

export const getCurrentDateString = () => {
  const today = startOfDay(new Date());
  return format(today, 'yyyy-MM-dd');
};
